import { useUnsavedChanges } from '../../contexts/UnsavedChangesContext';
import { ConfirmDialog } from './ConfirmDialog';

export function UnsavedChangesDialog() {
  const { isModalOpen, modalMessage, confirmNavigation, cancelNavigation } = useUnsavedChanges();

  return (
    <ConfirmDialog
      isOpen={isModalOpen}
      onClose={cancelNavigation}
      onConfirm={confirmNavigation}
      title="¿Salir sin guardar?"
      message={modalMessage}
      confirmText="Salir sin guardar"
      cancelText="Continuar editando"
      variant="warning"
    />
  );
}
